import axios, { API_URL } from './BaseService';

const PROFIT_MONITORS_URL = `${API_URL}/profit-monitors`;

export async function analyzeProfitMonitor(symbol, interval = '15m') {
    const response = await axios.get(`${PROFIT_MONITORS_URL}/analyze`, {
        params: { symbol, interval }
    });
    return response.data;
}

export async function getProfitMonitorInsight(symbol, interval = '15m') {
    const response = await axios.get(`${PROFIT_MONITORS_URL}/insight`, {
        params: { symbol, interval }
    });
    return response.data;
}

export async function getBuySignals(interval = '15m', symbols = []) {
    const response = await axios.get(`${PROFIT_MONITORS_URL}/buy-signals`, {
        params: {
            interval,
            symbols: symbols.filter(Boolean).join(',')
        }
    });
    return response.data;
}

export async function getProfitMonitors() {
    const response = await axios.get(PROFIT_MONITORS_URL);
    return response.data;
}

export async function startProfitMonitor(data) {
    const response = await axios.post(PROFIT_MONITORS_URL, data);
    return response.data;
}

export async function updateProfitMonitor(id, data) {
    const response = await axios.patch(`${PROFIT_MONITORS_URL}/${id}`, data);
    return response.data;
}

export async function stopProfitMonitor(id) {
    const response = await axios.post(`${PROFIT_MONITORS_URL}/${id}/stop`, {});
    return response.data;
}

export async function takeProfitMonitor(id) {
    const response = await axios.post(`${PROFIT_MONITORS_URL}/${id}/take-profit`, {});
    return response.data;
}

export async function deleteProfitMonitor(id) {
    await axios.delete(`${PROFIT_MONITORS_URL}/${id}`);
}
